export enum CUSTOMER_SUPPORT_FORM_FIELDS {
	NAME = 'customerSupportName',
	EMAIL = 'customerSupportEmail',
	PHONE = 'customerSupportPhone',
	LINK = 'customerSupportLink',
}

export enum CUSTOMER_SUPPORT_FORM_FIELDS_NAMES {
	NAME = 'NEW_APPLICATION.LABEL.CUSTOMER_NAME',
	LINK = 'NEW_APPLICATION.LABEL.SUPPORT_LINK',
	EMAIL = 'NEW_APPLICATION.LABEL.CUSTOMER_EMAIL',
	PHONE = 'NEW_APPLICATION.LABEL.CUSTOMER_PHONE',
}

export type CustomerSupportTypes = {
	[CUSTOMER_SUPPORT_FORM_FIELDS.NAME]: string,
	[CUSTOMER_SUPPORT_FORM_FIELDS.LINK]: string,
	[CUSTOMER_SUPPORT_FORM_FIELDS.EMAIL]: string,
	[CUSTOMER_SUPPORT_FORM_FIELDS.PHONE]: string,
};

export type CustomerSupportReturnTypes = {
	customerSupportName: string,
	customerSupportLink: string,
	customerSupportEmail: string,
	customerSupportPhone: string,
};

export const customerInitialValues: CustomerSupportTypes = {
	[CUSTOMER_SUPPORT_FORM_FIELDS.NAME]: '',
	[CUSTOMER_SUPPORT_FORM_FIELDS.LINK]: '',
	[CUSTOMER_SUPPORT_FORM_FIELDS.EMAIL]: '',
	[CUSTOMER_SUPPORT_FORM_FIELDS.PHONE]: '',
};

export const getFormattedCustomerFormFields = (formikValues): CustomerSupportReturnTypes => ({
	customerSupportName: formikValues?.[CUSTOMER_SUPPORT_FORM_FIELDS.NAME],
	customerSupportLink: formikValues?.[CUSTOMER_SUPPORT_FORM_FIELDS.LINK],
	customerSupportEmail: formikValues?.[CUSTOMER_SUPPORT_FORM_FIELDS.EMAIL],
	customerSupportPhone: formikValues?.[CUSTOMER_SUPPORT_FORM_FIELDS.PHONE]
});

export const convertCustomerSupportToInitial = (data): CustomerSupportTypes => ({
	[CUSTOMER_SUPPORT_FORM_FIELDS.NAME]: data?.customerSupportInformation?.customerSupportName ? data?.customerSupportInformation?.customerSupportName : '',
	[CUSTOMER_SUPPORT_FORM_FIELDS.LINK]: data?.customerSupportInformation?.customerSupportLink ? data?.customerSupportInformation?.customerSupportLink : '',
	[CUSTOMER_SUPPORT_FORM_FIELDS.EMAIL]: data?.customerSupportInformation?.customerSupportEmail ? data?.customerSupportInformation?.customerSupportEmail : '',
	[CUSTOMER_SUPPORT_FORM_FIELDS.PHONE]: data?.customerSupportInformation?.customerSupportPhone ? data?.customerSupportInformation?.customerSupportPhone : '',
});
